import { useEffect, useState } from "react";

/** True while the viewport matches the media query (re-evaluated on resize / rotation). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, [query]);
  return matches;
}

/** Phone layout: below Tailwind's `md` breakpoint, where the sidebar is already an off-canvas menu. */
export const useIsPhone = () => useMediaQuery("(max-width: 767px)");
